import React from 'react';
import {
  Container,
  Box,
  Typography,
} from '@mui/material';
import Header from '../components/common/Header';
import LabCatalogContent from '../components/common/LabCatalogContent';

const LabCatalog = () => {
  return (
    <Box sx={{ backgroundColor: '#f5f7fa', minHeight: '100vh', pb: 4 }}>
      {/* Header */}
      <Header />

      {/* Hero Section */}
      <Box
        sx={{
          background: '#2563eb',
          color: 'white',
          py: { xs: 4, md: 6 },
          position: 'relative',
          overflow: 'hidden',
        }}
      >
        <Container maxWidth="lg">
          <Typography
            variant="h3"
            component="h1"
            sx={{
              fontWeight: 700,
              mb: 2,
              fontSize: { xs: '2rem', md: '3rem' },
            }}
          >
            Order from 30+ labs in 20 seconds
          </Typography>
          <Typography
            variant="h6"
            sx={{
              fontWeight: 400,
              opacity: 0.9,
              fontSize: { xs: '1rem', md: '1.25rem' },
            }}
          >
            We make ordering quick and painless — and best of all, it's free for practitioners.{' '}
            <span style={{ color: '#cfefff', fontWeight: 500 }}>Contact your admin to get access.</span>
          </Typography>
        </Container>
      </Box>

      {/* Main Content */}
      <Container maxWidth="lg" sx={{ mt: 4 }}>
        <LabCatalogContent embedded={false} showComparison={true} />
      </Container>
    </Box>
  );
};

export default LabCatalog;
